export const ROLES = {
  ADMIN: 'administrator',
  MODERATOR: 'moderator',
}
